import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";

import check_description from "images/icons/icon_check_white.svg";

import "./EcourseHeader.style";

class EcourseHeader extends PolymerElement {
  static get template() {
    return html`
      <style include="ecourse-header-style"></style>
      <div class="search-webinar-header">
        <div class="search-webinar-container">
          <h1>Bahas Pengetahuan Klinis dengan Pakar Kedokteran</h1>
          <ul class="description-list">
            <li>
              <img src$="[[iconCheckDescription]]" alt="alomedika" />
              Sertifikat dari Perhimpunan
            </li>
            <li>
              <img src$="[[iconCheckDescription]]" alt="alomedika" />
              Lebih Hemat dari Kursus Offline
            </li>
            <li>
              <img src$="[[iconCheckDescription]]" alt="alomedika" />
              Akses Dimanapun & Kapanpun
            </li>
          </ul>
        </div>
      </div>
    `;
  }

  static get properties() {
    return {
      iconCheckDescription: {
        type: String,
        value: check_description,
      },
    };
  }
}
customElements.define("ecourse-header", EcourseHeader);
